import { SupportedArtworkSizes } from 'constants/supportedArtworksSizes';
import React from 'react';
import { getImageUrl } from 'helpers/getImageUrl';
import { Image, Skeleton } from '@landr/maestro';
import { styles } from './styled';
import { BackgroundImageFromUrlProps } from './types';

const BackgroundImageFromUrl: React.FC<BackgroundImageFromUrlProps> = ({
    isLoading = false,
    imageUrl,
    imageSize = 'heroSlide',
    fallback,
    fallbackSrc,
    alt,
    loading = 'lazy',
    backgroundColor,
}) => {
    if (isLoading || (!imageUrl && !fallback && !fallbackSrc)) {
        return <Skeleton className={styles.backgroundSkeleton} />;
    }

    const [imageWidth, imageHeight] = SupportedArtworkSizes[imageSize];

    const src = getImageUrl({
        imageUrl,
        width: imageWidth,
        height: imageHeight,
    });
    const src2x = getImageUrl({
        imageUrl,
        width: imageWidth * 2,
        height: imageHeight * 2,
    });
    const srcSet = `${src2x} 2x, ${src}`;

    return (
        <Image
            className={styles.backgroundImage}
            src={src}
            srcSet={srcSet}
            alt={alt}
            fallback={fallback}
            fallbackSrc={fallbackSrc}
            loading={loading}
            backgroundColor={backgroundColor}
        />
    );
};

export default BackgroundImageFromUrl;
